class QuickBuyCard extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els?.select?.exists) return

    this.handleChange = this.handleChange.bind(this)

    this.listeners.add(this.els.select.element, `change`, this.handleChange)

    this.listeners.add(
      this.els['bis-trigger'].element,
      `click`,
      this.handleBISView.bind(this),
    )

    if (this.els.color) {
      this.els.color.elements.forEach(el =>
        el.addEventListener(`click`, this.handleProductUpdate.bind(this)),
      )
    }
  }

  handleChange (event) {
    const variantAvailable =
      event.target.selectedOptions[0].getAttribute('data-available') === 'true'

    if (!variantAvailable) {
      this.handleBISView()
    }

    this.els['atc-button'].element.setAttribute(
      'aria-hidden',
      !variantAvailable,
    )
  }

  handleBISView () {
    this.els['bis-view'].element.setAttribute('aria-hidden', false)
    this.els['purchase-view'].element.setAttribute('aria-hidden', true)
    this.els['bis-view'].element
      .querySelector('form')
      .setAttribute('variant-id', this.els.select.element.value)
  }

  handleProductUpdate (event) {
    const customEvent = new CustomEvent('quickbuy:update-product', {
      detail: {
        name: event.target.dataset.productUrl,
        bubbles: true,
      },
    })
    document.dispatchEvent(customEvent)
  }
}

if (!customElements.get('quick-buy-card')) {
  customElements.define('quick-buy-card', QuickBuyCard)
}
